import { useState, useEffect, useRef } from 'react';
import { useOutletContext } from 'react-router-dom';
import Modal from '../../components/common/Modal';
import { collectionLanguageWithLabels } from 'utils/languages';
import './Collections.css';
import {
  Button,
  Grid,
  Box,
  Fade,
  CircularProgress,
  LinearProgress,
  InputLabel,
  TextField,
  Typography,
} from '@mui/material';
import NotInterestedOutlinedIcon from '@mui/icons-material/NotInterestedOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
  deleteVideoTrailer,
  deleteTrailerSubtitle,
  deleteAudio,
} from './Resources';
import { Controller } from 'react-hook-form';
import Uploader from '../../components/uploader/Uploader';
import { Form } from 'react-bootstrap';
import { AsyncPaginate } from 'react-select-async-paginate';
import { getMediaTrailerById } from './Resources';
import { Tooltip } from 'components/Tooltip';
import { useGlobalStore } from 'store/globalStore';
import { useAppProviderStore } from 'store/appProviderCopyStore';
import ClosedCaptionIcon from '@mui/icons-material/ClosedCaption';
import Chip from '@mui/material/Chip';
import SurroundSoundIcon from '@mui/icons-material/SurroundSound';
import { useNotification } from 'hooks/useNotification';

function CollectionStep2(props) {
  const {
    register,
    control,
    getValues,
    setValue,
    languages,
    viewFields,
    collectionResponse,
  } = props;
  const {
    trailerUploadProgress,
    legendaTrailerUploadProgress,
    audioTrailerUploadProgress,
  } = useAppProviderStore();
  const [isLoading, setIsLoading] = useState(false);
  const { setNotify } = useNotification();
  const [auth, setAuth] = useOutletContext();
  const [trailerDefaultLanguage, setTrailerDefaultLanguage] = useState([]);
  const fileInputVideoTrailerRef = useRef(null);
  const [trailerVideoFiles, setTrailerVideoFiles] = useState([]);
  const [trailerSubtitle, setTrailerSubtitle] = useState([]);
  const fileInputTrailerSubtitleRef = useRef(null);
  const [subtitleTrailerFiles, setSubtitleTrailerFiles] = useState([]);
  const [audioFiles, setAudioFiles] = useState([]);
  const fileInputAudioRef = useRef(null);
  const [canAddAudio, setCanAddAudio] = useState(false);
  const [audioIdioma, setAudioIdioma] = useState([]);
  const { showConfirmationButton } = useState(true);
  const [confirmDialogAction, setConfirmDialogAction] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
  });

  const session = auth;
  const idToken = session.getIdToken().getJwtToken();
  const userId = session.getIdToken().payload.sub;
  const userName = session.getIdToken().payload.username;
  const { setCancelUpload } = useGlobalStore();

  useEffect(() => {
    (async () => {
      // let trailerId = collectionResponse?.trailerId;
      let trailerId = getValues('trailerId');
      if (trailerId) {
        await getMediaTrailerById(
          auth,
          trailerId,
          setTrailerDefaultLanguage,
          () => {},
          setTrailerVideoFiles,
          setSubtitleTrailerFiles,
          setTrailerSubtitle,
          setValue,
          () => {}, //setVideoProps, setVideoProps is not being used
          setAuth,
          setNotify,
          setAudioFiles,
          setAudioIdioma
        );
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collectionResponse]);

  const handleResetLanguage = () => {
    setValue('subtitle_trailer_language', null);
    setValue('audio_idioma', null);
  };

  useEffect(() => {
    if (isLoading === false) {
      handleResetLanguage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);
  const uploadVerification = file => {
    return !!(file?.percent > 0 && file?.percent < 100);
  };

  async function handleDeleteMedia(
    mediaId,
    idioma,
    videoUploadProgress,
    id,
    version
  ) {
    setConfirmDialogAction({ isOpen: false });
    let path = `/${id}/versions/${version}/media/${mediaId}`;
    if (uploadVerification(videoUploadProgress)) {
      setCancelUpload(true);
      setNotify({
        isOpen: true,
        message: 'Processo de upload interrompido pelo usuário!',
        type: 'success',
        title: 'Sucesso!',
      });
      deleteVideoTrailer(
        path,
        setIsLoading,
        setConfirmDialogAction,
        setNotify,
        setTrailerVideoFiles,
        setTrailerDefaultLanguage,
        setSubtitleTrailerFiles,
        setAudioFiles,
        setValue
      );
    } else {
      deleteVideoTrailer(
        path,
        setIsLoading,
        setConfirmDialogAction,
        setNotify,
        setTrailerVideoFiles,
        setTrailerDefaultLanguage,
        setSubtitleTrailerFiles,
        setAudioFiles,
        setValue
      );
    }
  }

  const deleteFilesFromList = (files, setFiles, indexToRemove) => {
    const updatedItems = files.filter((item, index) => index !== indexToRemove);
    setFiles && setFiles(updatedItems);
    return updatedItems;
  };

  return (
    <div
      className="step-container"
      style={{ position: 'relative' }}
      id="collection-step-two">
      <Box className={isLoading ? 'isLoading' : ''}>
        <Fade
          in={isLoading}
          style={{
            transitionDelay: isLoading ? '800ms' : '0ms',
          }}
          unmountOnExit>
          <CircularProgress />
        </Fade>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className="video_label-title">Trailer</div>
        </Grid>
        {trailerVideoFiles?.trailer?.trailerId && (
          <>
            <Grid item xs={4}>
              <Form.Group style={{ height: 'auto' }} controlId="formUnit">
                <InputLabel
                  className="form-label"
                  id="select-standard-label"
                  htmlFor="units">
                  Idioma do áudio do trailer
                </InputLabel>
                <TextField
                  value={
                    trailerDefaultLanguage?.label ||
                    trailerDefaultLanguage[0]?.label
                  }
                  fullWidth
                  variant="standard"
                  disabled={true}
                  style={{ marginTop: 6 }}
                  id="collection-audio-trailer"
                />
              </Form.Group>
            </Grid>
            <Grid item xs={8}>
              <Form.Group
                style={{ height: 'auto', paddingRight: 15 }}
                controlId="formVideoFile">
                <div className="file-container">
                  <div>
                    <InputLabel
                      className="select-label"
                      style={{ marginBottom: 25, marginTop: 0 }}>
                      Arquivo
                    </InputLabel>

                    <Controller
                      name={'video_media'}
                      control={control}
                      render={({
                        field: { onChange, value, onBlur },
                        fieldState: { error, invalid, isTouched, isDirty },
                        formState,
                      }) => (
                        <span
                          // onClick={ClickHandler}
                          // href="/"
                          style={{
                            fontWeight: '400',
                            color: '#0000CC',
                            borderBottom: '1px solid rgba(208, 213, 221, 1)',
                            textDecoration: 'none',
                          }}
                          onChange={e => {
                            onChange(e);
                            // setSelectedName(e.target.value)
                          }}
                          value={value}
                          onBlur={onBlur}
                          disabled={viewFields}
                          id="collection-trailer-filename">
                          {trailerVideoFiles?.trailer?.name}
                        </span>
                      )}
                    />
                  </div>
                  <Button
                    disabled={viewFields}
                    id="collection-trailer-remove-button"
                    color="error"
                    style={{
                      textTransform: 'capitalize',
                      color: 'rgba(255, 98, 98, 1)',
                    }}
                    startIcon={<NotInterestedOutlinedIcon />}
                    onClick={async () => {
                      setConfirmDialogAction({
                        isOpen: true,
                        title: (
                          <div className="modalTitleText">
                            Deseja remover a mídia?
                          </div>
                        ),
                        subTitle: (
                          <div className="modalBodyText">
                            Você está deletando o arquivo permanentemente,
                            deseja prosseguir?
                          </div>
                        ),
                        children: (
                          <div className="modalRemoveItem">
                            <DeleteOutlineOutlinedIcon
                              color="error"
                              fontSize="12px"
                            />
                          </div>
                        ),
                        confirmTextButton: 'Sim',
                        color: 'error',
                        onConfirm: async () => {
                          setConfirmDialogAction({ isOpen: false });
                          await handleDeleteMedia(
                            getValues('trailerId'),
                            trailerDefaultLanguage[0],
                            trailerUploadProgress,
                            getValues('id'),
                            getValues('version')
                          );
                        },

                        showConfirmationButton: { showConfirmationButton },
                        closeTextButton: 'Não',
                      });
                    }}>
                    {uploadVerification(trailerUploadProgress)
                      ? 'Cancelar'
                      : 'Remover'}
                  </Button>
                </div>
              </Form.Group>
            </Grid>
          </>
        )}
        {!trailerVideoFiles?.trailer?.trailerId && (
          <Grid
            item
            xs={4}
            className={
              trailerVideoFiles?.trailer?.trailerId
                ? 'select-label hidden'
                : 'select-label '
            }>
            <Form.Group style={{ height: 'auto' }} controlId="formUnit">
              <InputLabel>Idioma do áudio do trailer</InputLabel>
              <Controller
                name={'trailer_audio_language'}
                control={control}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { errors, isValid, isTouched, isDirty },
                  formState,
                }) => (
                  <AsyncPaginate
                    id="collection-trailer-audio-language"
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        '&:hover': {
                          borderColor: 'transparent',
                          borderRadius: '0px',
                          border: 0,
                          borderBottom: '1px solid var(--gray-300, #D0D5DD)',
                        },
                        borderRadius: '0px',
                        border: 0,
                        borderBottom: '1px solid var(--gray-300, #D0D5DD)',
                        width: 'auto',
                        padding: 0,
                        margin: 0,
                        marginTop: '10px',
                      }),
                      singleValue: base => ({
                        ...base,
                        // padding: 5,
                        borderRadius: 6,
                        color: 'rgba(25, 28, 31, 1)',
                        fontSize: '15px',
                        display: 'flex',
                      }),
                      menuList: base => ({
                        ...base,
                        maxHeight: '150px',
                      }),
                    }}
                    theme={theme => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary25: '#e9e9ea',
                        primary: '#0A6CCF',
                        width: 'auto',
                      },
                    })}
                    menuPosition="fixed"
                    noOptionsMessage={() => 'Nada encontrado'}
                    loadingMessage={() => 'Carregando...'}
                    loadOptions={collectionLanguageWithLabels}
                    // isMulti
                    value={value || { value: '', label: 'Selecione o Idioma' }}
                    isSearchable={false}
                    onBlur={e => {
                      onBlur(e);
                    }}
                    isDisabled={viewFields}
                    placeholder="Selecione o idioma"
                    onChange={selectedOption => {
                      onChange(selectedOption);
                      setTrailerDefaultLanguage(prevSubtitle => [
                        ...prevSubtitle,
                        selectedOption,
                      ]);
                    }}
                  />
                )}
              />
            </Form.Group>
          </Grid>
        )}
        <Grid item xs={8}>
          <div className="file-container">
            <div>
              <InputLabel
                className={
                  trailerVideoFiles?.trailer?.trailerId
                    ? 'select-label hidden'
                    : 'select-label '
                }
                style={{ marginBottom: 12, marginTop: 0 }}>
                Trailer
              </InputLabel>
              <Tooltip.Info
                title="Atenção"
                description="Antes de selecionar o arquivo selecione o idioma"
                show={
                  !trailerVideoFiles?.trailer?.trailerId &&
                  (!getValues('trailer_audio_language') ||
                    getValues('trailerId') ||
                    viewFields)
                }>
                <Uploader
                  register={register}
                  name={'trailer_file'}
                  icon={<FileUploadOutlinedIcon />}
                  accept={
                    'video/AIV,video/MP4,video/MOV,video/WEBM,video/MXF,video/WMV,video/MPEG,video/3GP,video/ASF,video/mp4,video/x-m4v,video/*'
                  }
                  fileInputRef={fileInputVideoTrailerRef}
                  file={trailerVideoFiles}
                  title={'Selecionar Trailer'}
                  isDisabled={
                    !getValues('trailer_audio_language') ||
                    getValues('trailerId') ||
                    viewFields
                  }
                  mediaContentType={'COLLECTION'}
                  apiName={'admin'}
                  path={`/admin/media`}
                  token={idToken}
                  id={getValues('id')}
                  language={getValues('trailer_audio_language')}
                  userId={userId}
                  userName={userName}
                  setIsLoading={setIsLoading}
                  isLoading={isLoading}
                  setProps={setTrailerVideoFiles}
                  setNotify={setNotify}
                  type={{ label: 'video', name: 'TRAILER' }}
                  getValues={getValues}
                  setValue={setValue}
                  setAuth={setAuth}
                />
              </Tooltip.Info>
              {trailerUploadProgress?.percent > 0 &&
                trailerUploadProgress?.percent < 100 && (
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{ width: '100%', mr: 1 }}>
                      <label style={{ fontSize: '12px', color: 'blue' }}>
                        {trailerUploadProgress?.name}
                      </label>
                      <LinearProgress
                        variant="determinate"
                        value={trailerUploadProgress?.percent}
                      />
                    </Box>
                    <Box sx={{ minWidth: 35 }}>
                      <Typography variant="body2" color="text.secondary">
                        {trailerUploadProgress?.percent}%
                      </Typography>
                    </Box>
                  </Box>
                )}
            </div>
          </div>
        </Grid>

        <Grid item xs={12} style={{ marginTop: 15 }}>
          <div className="video_label-title">Legenda(s) do trailer</div>
        </Grid>

        {subtitleTrailerFiles.map(
          (file, index) =>
            trailerSubtitle[index] && (
              <Grid container spacing={2} key={index} sx={{ padding: '15px' }}>
                <Grid item xs={4}>
                  <Form.Group style={{ height: 'auto' }} controlId="formUnit">
                    <InputLabel
                      className="form-label"
                      id="select-standard-label"
                      htmlFor="units">
                      Idioma
                    </InputLabel>
                    <TextField
                      value={subtitleTrailerFiles[index]?.label}
                      fullWidth
                      variant="standard"
                      disabled={true}
                      style={{ marginTop: 6 }}
                      id={`collection-language-trailer-subtitle-${index}`}
                    />
                  </Form.Group>
                </Grid>

                <Grid item xs={8}>
                  <div className="file-container">
                    <div style={{ maxWidth: '300px' }}>
                      <InputLabel
                        className="select-label"
                        style={{ marginBottom: 24, marginTop: 0 }}>
                        Arquivo
                        <span
                          name={'audio_' + index + '_idioma'}
                          href="/"
                          //onClick={ClickHandler}
                          disabled={viewFields}
                          id="video-subtitle-accessibility">
                          {file.accessibility === 'true' ||
                          file.accessibility === true ? (
                            <Chip
                              icon={<ClosedCaptionIcon color="primary" />}
                              label="Legenda - Closed Caption"
                              sx={{ fontSize: '12px', marginLeft: '5px' }}
                              size="small"
                            />
                          ) : (
                            ''
                          )}
                        </span>
                      </InputLabel>

                      <span
                        //onClick={ClickHandler}
                        name={'legenda_' + index + '_idioma'}
                        //href="#"
                        style={{
                          fontWeight: '400',
                          color: '#0000CC',
                          borderBottom: '1px solid rgba(208, 213, 221, 1)',
                          textDecoration: 'none',
                          overflowWrap: 'break-word',
                        }}
                        disabled={viewFields}
                        id="collection-trailer-subtitle-filename">
                        {file.name}
                      </span>
                    </div>
                    <Button
                      // disabled={viewFields}
                      disabled={
                        legendaTrailerUploadProgress?.percent === 100 ||
                        viewFields ||
                        legendaTrailerUploadProgress === false
                          ? false
                          : true
                      }
                      color="error"
                      style={{
                        textTransform: 'capitalize',
                        color:
                          legendaTrailerUploadProgress?.percent === 100 ||
                          legendaTrailerUploadProgress === false ||
                          viewFields
                            ? 'rgba(255, 98, 98, 1)'
                            : 'rgba(0, 0, 0, 0.38)',
                      }}
                      startIcon={<NotInterestedOutlinedIcon />}
                      onClick={async () => {
                        setConfirmDialogAction({
                          isOpen: true,
                          title: (
                            <div className="modalTitleText">
                              Deseja remover a mídia?
                            </div>
                          ),
                          subTitle: (
                            <div className="modalBodyText">
                              Você está deletando o arquivo permanentemente,
                              deseja prosseguir?
                            </div>
                          ),
                          children: (
                            <div className="modalRemoveItem">
                              <DeleteOutlineOutlinedIcon
                                color="error"
                                fontSize="12px"
                              />
                            </div>
                          ),
                          confirmTextButton: 'Sim',
                          color: 'error',
                          onConfirm: async () => {
                            setConfirmDialogAction({ isOpen: false });
                            let trailerId = '';
                            let subtitleId = '';
                            let sub = getValues('subtitle_trailerId');
                            if (sub) {
                              let findSub = sub.find(obj => {
                                return obj.name === file.name;
                              });
                              trailerId = findSub?.mediaId;
                              subtitleId = findSub?.subtitleId;
                            } else {
                              trailerId = getValues('trailerId');
                              subtitleId = file?.subtitleId;
                            }
                            await deleteTrailerSubtitle(
                              trailerId,
                              subtitleId,
                              setIsLoading,
                              setConfirmDialogAction
                            );
                            deleteFilesFromList(
                              subtitleTrailerFiles,
                              setSubtitleTrailerFiles,
                              index
                            );
                            deleteFilesFromList(
                              trailerSubtitle,
                              setTrailerSubtitle,
                              index
                            );
                            setValue(
                              'subtitle_trailer_language',
                              deleteFilesFromList(trailerSubtitle, false, index)
                            );
                          },
                          showConfirmationButton: { showConfirmationButton },
                          closeTextButton: 'Não',
                        });
                      }}>
                      Remover
                    </Button>
                  </div>
                </Grid>
              </Grid>
            )
        )}
        <>
          <Grid item xs={4}>
            <Form.Group
              style={{ height: 'auto' }}
              controlId="formUnit"
              id="collection-subtitle-trailer-language">
              <Controller
                name={'subtitle_trailer_language'}
                control={control}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { errors, isValid, isTouched, isDirty },
                  formState,
                }) => {
                  return (
                    <Box
                      sx={{
                        display: 'grid',
                        gridTemplateColumns: '224px auto',
                        gap: 2,
                      }}>
                      <Box>
                        <InputLabel className="select-label">Idioma</InputLabel>
                        <AsyncPaginate
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              '&:hover': {
                                borderColor: 'transparent',
                                borderRadius: '0px',
                                border: 0,
                                borderBottom:
                                  '1px solid var(--gray-300, #D0D5DD)',
                              },
                              borderRadius: '0px',
                              border: 0,
                              borderBottom:
                                '1px solid var(--gray-300, #D0D5DD)',
                              width: 'auto',
                              padding: 0,
                              margin: 0,
                            }),
                            singleValue: base => ({
                              ...base,
                              // padding: 5,
                              borderRadius: 6,
                              color: 'rgba(25, 28, 31, 1)',
                              fontSize: '15px',
                              display: 'flex',
                            }),
                            menuList: base => ({
                              ...base,
                              maxHeight: '150px',
                            }),
                          }}
                          theme={theme => ({
                            ...theme,
                            borderRadius: 0,
                            colors: {
                              ...theme.colors,
                              primary25: '#e9e9ea',
                              primary: '#0A6CCF',
                              width: 'auto',
                            },
                          })}
                          menuPosition="fixed"
                          noOptionsMessage={() => 'Nada encontrado'}
                          loadingMessage={() => 'Carregando...'}
                          loadOptions={collectionLanguageWithLabels}
                          isDisabled={!getValues('trailerId') || viewFields}
                          value={
                            value || { value: '', label: 'Selecione o Idioma' }
                          }
                          isSearchable={false}
                          placeholder="Selecione o idioma"
                          onChange={selectedOption => {
                            onChange(selectedOption);
                            setTrailerSubtitle(prevSubtitle => [
                              ...prevSubtitle,
                              selectedOption,
                            ]);
                          }}
                        />
                      </Box>
                      <Box>
                        <InputLabel
                          className="select-label"
                          style={{ marginTop: 0, marginBottom: 6 }}>
                          Arquivo
                        </InputLabel>
                        <Tooltip.Info
                          title="Atenção"
                          description="Antes de selecionar o arquivo selecione o idioma"
                          show={
                            !getValues('subtitle_trailer_language') ||
                            viewFields
                          }>
                          <Uploader
                            register={register}
                            name={'subtitle_trailer_language_file'}
                            icon={<FileUploadOutlinedIcon />}
                            mediaContentType={'COLLECTION'}
                            accept={'.srt,.txt,.vvt'}
                            fileInputRef={fileInputTrailerSubtitleRef}
                            file={subtitleTrailerFiles}
                            title={'Selecionar legenda'}
                            isDisabled={
                              !getValues('subtitle_trailer_language') ||
                              viewFields
                            }
                            apiName={'admin'}
                            path={`/admin/media/${getValues('trailerId')}/subtitles`}
                            token={idToken}
                            id={getValues('id')}
                            language={getValues('subtitle_trailer_language')}
                            languages={languages}
                            userId={userId}
                            userName={userName}
                            setIsLoading={setIsLoading}
                            isLoading={isLoading}
                            setProps={setSubtitleTrailerFiles}
                            setNotify={setNotify}
                            type={{ label: 'legenda', name: 'TRAILER' }}
                            getValues={getValues}
                            setValue={setValue}
                            setAuth={setAuth}
                            isAcessibilityCheck={true}
                            nameIsAcessibilityCheck={'legend'}
                          />
                        </Tooltip.Info>
                        {legendaTrailerUploadProgress?.percent > 0 &&
                          legendaTrailerUploadProgress?.percent < 100 && (
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                              <Box sx={{ width: '100%', mr: 1 }}>
                                <label
                                  style={{ fontSize: '12px', color: 'blue' }}>
                                  {legendaTrailerUploadProgress?.name}
                                </label>
                                <LinearProgress
                                  variant="determinate"
                                  value={legendaTrailerUploadProgress?.percent}
                                />
                              </Box>
                              <Box sx={{ minWidth: 35 }}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary">
                                  {legendaTrailerUploadProgress?.percent}%
                                </Typography>
                              </Box>
                            </Box>
                          )}
                      </Box>{' '}
                    </Box>
                  );
                }}
              />
            </Form.Group>
          </Grid>
        </>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div
            className="video_label-title"
            style={{ marginTop: 35, marginBottom: 25 }}>
            Áudio do trailer
          </div>
        </Grid>

        {audioFiles &&
          audioFiles.map(
            (file, index) =>
              audioIdioma[index] && (
                <Grid
                  container
                  spacing={2}
                  key={index}
                  sx={{ padding: '15px' }}>
                  <Grid item xs={4}>
                    <Form.Group
                      className="mb-3"
                      style={{ height: 'auto' }}
                      controlId="formUnit">
                      <InputLabel
                        className="form-label"
                        id="select-standard-label"
                        htmlFor="audioIdioma">
                        Idioma
                      </InputLabel>
                      <TextField
                        value={audioFiles[index]?.label}
                        fullWidth
                        disabled={audioFiles[index]?.mediaId || viewFields}
                        //
                        variant="standard"
                        style={{ marginTop: 6 }}
                        id={`collection-audio-language-${index}`}
                      />
                    </Form.Group>
                  </Grid>

                  <Grid item xs={8}>
                    <div className="file-container">
                      <div style={{ width: '500px' }}>
                        <InputLabel
                          className="select-label"
                          style={{ marginBottom: 24, marginTop: 0 }}>
                          Arquivo
                          <span
                            name={'audio_' + index + '_idioma'}
                            href="/"
                            //onClick={ClickHandler}
                            disabled={viewFields}
                            id="video-subtitle-accessibility">
                            {file.accessibility === 'true' ||
                            file.accessibility === true ? (
                              <Chip
                                icon={<SurroundSoundIcon color="primary" />}
                                label="Áudio descrição"
                                sx={{ fontSize: '12px', marginLeft: '5px' }}
                                size="small"
                              />
                            ) : (
                              ''
                            )}
                          </span>
                        </InputLabel>

                        <span
                          name={'audio_' + index + '_idioma'}
                          style={{
                            fontWeight: '400',
                            color: '#0000CC',
                            borderBottom: '1px solid rgba(208, 213, 221, 1)',
                            textDecoration: 'none',
                          }}
                          disabled={viewFields}
                          id="collection-trailer-subtitle-finame">
                          {file.name}
                        </span>
                      </div>
                      <Button
                        // disabled={viewFields}
                        disabled={
                          audioTrailerUploadProgress?.percent === 100 ||
                          viewFields ||
                          audioTrailerUploadProgress === false
                            ? false
                            : true
                        }
                        color="error"
                        style={{
                          textTransform: 'capitalize',
                          color:
                            audioTrailerUploadProgress?.percent === 100 ||
                            audioTrailerUploadProgress === false ||
                            viewFields
                              ? 'rgba(255, 98, 98, 1)'
                              : 'rgba(0, 0, 0, 0.38)',
                        }}
                        startIcon={<NotInterestedOutlinedIcon />}
                        onClick={async () => {
                          setConfirmDialogAction({
                            isOpen: true,
                            title: (
                              <div className="modalTitleText">
                                Deseja remover a mídia?
                              </div>
                            ),
                            subTitle: (
                              <div className="modalBodyText">
                                Você está deletando o arquivo permanentemente,
                                deseja prosseguir?
                              </div>
                            ),
                            children: (
                              <div className="modalRemoveItem">
                                <DeleteOutlineOutlinedIcon
                                  color="error"
                                  fontSize="12px"
                                />
                              </div>
                            ),
                            confirmTextButton: 'Sim',
                            color: 'error',
                            onConfirm: async () => {
                              setConfirmDialogAction({ isOpen: false });
                              let path = `/${getValues(
                                'trailerId'
                              )}/audio-tracks/${audioFiles[index].audioTrackId}`;
                              await deleteAudio(
                                audioFiles[index],
                                path,
                                setIsLoading,
                                setNotify,
                                setConfirmDialogAction
                              );

                              deleteFilesFromList(
                                audioFiles,
                                setAudioFiles,
                                index
                              );
                              deleteFilesFromList(
                                audioIdioma,
                                setAudioIdioma,
                                index
                              );
                              setValue(
                                'audio_idioma',
                                deleteFilesFromList(audioIdioma, false, index)
                              );

                              setNotify({
                                isOpen: true,
                                message: 'Áudio removido com sucesso.',
                                type: 'success',
                                title: 'Sucesso!',
                              });
                            },
                            showConfirmationButton: { showConfirmationButton },
                            closeTextButton: 'Não',
                          });
                        }}
                        id="collection-remove-subtitle-button">
                        Remover
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              )
          )}
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Form.Group
            className="mb-3"
            style={{ height: 'auto', marginTop: 10 }}
            controlId="formUnit">
            <Controller
              name={'audio_idioma'}
              control={control}
              render={({
                field: { onChange, value, onBlur },
                fieldState: { errors, isValid, isTouched, isDirty },
                formState,
              }) => (
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: '224px auto',
                    gap: 2,
                  }}>
                  <Box>
                    <InputLabel
                      className="form-label"
                      id="select-standard-label"
                      htmlFor="units">
                      Idioma
                    </InputLabel>
                    <AsyncPaginate
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          '&:hover': {
                            borderColor: 'transparent',
                            borderRadius: '0px',
                            border: 0,
                            borderBottom: '1px solid var(--gray-300, #D0D5DD)',
                          },
                          borderRadius: '0px',
                          border: 0,
                          borderBottom: '1px solid var(--gray-300, #D0D5DD)',
                          width: 'auto',
                          padding: 0,
                          margin: 0,
                        }),
                        singleValue: base => ({
                          ...base,
                          // padding: 5,
                          borderRadius: 6,
                          color: 'rgba(25, 28, 31, 1)',
                          fontSize: '15px',
                          display: 'flex',
                        }),
                        menuList: base => ({
                          ...base,
                          maxHeight: '150px',
                        }),
                      }}
                      theme={theme => ({
                        ...theme,
                        borderRadius: 0,
                        colors: {
                          ...theme.colors,
                          primary25: '#e9e9ea',
                          primary: '#0A6CCF',
                          width: 'auto',
                        },
                      })}
                      menuPosition="fixed"
                      noOptionsMessage={() => 'Nada encontrado'}
                      loadingMessage={() => 'Carregando...'}
                      loadOptions={collectionLanguageWithLabels}
                      // isMulti
                      value={
                        value || { value: '', label: 'Selecione o Idioma' }
                      }
                      isDisabled={
                        (!getValues('trailerId') && !canAddAudio) || viewFields
                      }
                      // || viewStepOneFields
                      isSearchable={false}
                      placeholder="Selecione o idioma"
                      onChange={selectedOption => {
                        onChange(selectedOption);
                        setCanAddAudio(true);
                        setAudioIdioma(prevAudio => [
                          ...prevAudio,
                          selectedOption,
                        ]);
                      }}
                      id="collection-audio-traller-select"
                    />
                  </Box>
                  <Box>
                    <InputLabel
                      className="select-label"
                      style={{ marginTop: 4, marginBottom: 12 }}>
                      Arquivo
                    </InputLabel>
                    <Tooltip.Info
                      title="Atenção"
                      description="Antes de selecionar o arquivo selecione o idioma"
                      show={!canAddAudio || viewFields}>
                      <Uploader
                        register={register}
                        name={'audio_file'}
                        mediaContentType={'COLLECTION'}
                        icon={<FileUploadOutlinedIcon />}
                        accept=".mp3, .wav, .aiff, .flac"
                        fileInputRef={fileInputAudioRef}
                        file={audioFiles}
                        title={'Selecionar faixa'}
                        isDisabled={!canAddAudio || viewFields}
                        apiName={'admin'}
                        path={`/admin/media/${getValues(
                          'trailerId'
                        )}/audio-tracks`}
                        token={idToken}
                        id={getValues('id')}
                        language={getValues('audio_idioma')}
                        userId={userId}
                        userName={userName}
                        setIsLoading={setIsLoading}
                        isLoading={isLoading}
                        setProps={setAudioFiles}
                        setNotify={setNotify}
                        type={{
                          label: 'audio',
                          name: 'MAIN',
                          model: 'TRAILER',
                        }}
                        getValues={getValues}
                        setValue={setValue}
                        setAuth={setAuth}
                        isAcessibilityCheck={true}
                        nameIsAcessibilityCheck={'audio'}
                      />
                    </Tooltip.Info>
                    {audioTrailerUploadProgress?.percent > 0 &&
                      audioTrailerUploadProgress?.percent < 100 && (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Box sx={{ width: '100%', mr: 1 }}>
                            <label style={{ fontSize: '12px', color: 'blue' }}>
                              {audioTrailerUploadProgress?.name}
                            </label>
                            <LinearProgress
                              variant="determinate"
                              value={audioTrailerUploadProgress?.percent}
                            />
                          </Box>
                          <Box sx={{ minWidth: 35 }}>
                            <Typography variant="body2" color="text.secondary">
                              {audioTrailerUploadProgress?.percent}%
                            </Typography>
                          </Box>
                        </Box>
                      )}
                  </Box>
                </Box>
              )}
            />
          </Form.Group>
        </Grid>
      </Grid>
      <Modal
        confirmDialogAction={confirmDialogAction}
        setConfirmDialogAction={setConfirmDialogAction}
      />
    </div>
  );
}

export default CollectionStep2;
